import React from "react";
import SlimView from "../components/slim/SlimView";
import { ConfigurationProvider, useConfiguration } from "../context/ConfigurationContext";

const SlimViewWrapper: React.FC = () => {
  const { thinConfig } = useConfiguration();
  return <SlimView config={thinConfig} />;
};

const SlimViewPage: React.FC = () => {
  return (
    <ConfigurationProvider>
      <SlimViewWrapper />
    </ConfigurationProvider>
  );
};

export default SlimViewPage;
